import React from 'react';
import { Box, Heading, Text } from '@wix/design-system';
import s from './TitleAndSubTitle.scss';

export const MobileTitleAndSubTitle: React.FC<{
  title: string;
  subtitle: string;
}> = ({ title, subtitle }) => {
  return (
    <Box
      className={s.titleSection}
      direction="vertical"
      maxWidth="680px"
      align="center"
      textAlign="center"
    >
      <Box paddingBottom="SP1">
        <Heading dataHook="app-title" appearance="H2">
          {title}
        </Heading>
      </Box>
      <Text dataHook="app-subtitle">{subtitle}</Text>
    </Box>
  );
};
